import React, { Component } from "react";
import ProductHeader from "../../ProductDetails/ProductHeader";
import { ReactComponent as Error } from "../assets/error.svg";
import { ReactComponent as PaymentDeclined } from "../assets/payment-declined.svg";
import { connect } from "react-redux";
import ActionButton from "../../ActionButton";
import { Redirect } from "react-router";
import { clearLastOrder } from "../../../store/actions";
import instance from "../../../store/actions/instance";
import CircularProgress from "@material-ui/core/CircularProgress";

class index extends Component {
  state = {
    failedPromise: null,
    loading: false,
  };

  fetchPromisePaymentDetails = async (pm) => {
    this.setState({ loading: true });
    let res = null;
    res = await instance.get(
      `/fetch_${pm}_fail_data/${this.props.match.params.Tid.trim()}/`
    );
    if (res.data.success) {
      this.setState({ failedPromise: res.data.promise });
    }
    this.setState({ loading: false });
  };
  componentDidMount = () => {
    if (
      this.props.match.params.Tid &&
      this.props.lastOrder &&
      !this.props.history.location.state &&
      (this.props.match.params.pm == "knet" ||
        this.props.match.params.pm == "benefit" ||
        this.props.match.params.pm === "tpay")
    ) {
      // THis is back from knet payment gateway
      this.fetchPromisePaymentDetails(this.props.match.params.pm);
    }
  };
  render() {
    const { language, settings, customerContact } = this.props;
    const { failedPromise } = this.state;

    if (!this.props.history.location.state && !this.props.match.params.Tid) {
      return <Redirect to="/" />;
    }
    if (this.props.match.params.Tid && !this.props.lastOrder) {
      return <Redirect to="/" />;
    }
    let message;
    let paymentError = false;
    if (!this.props.history.location.state && this.props.match.params.Tid) {
      if (
        this.props.match.params.Tid.split("-").slice(0, 2).join("-") !=
        this.props.lastOrder.tracking_id
      ) {
        return <Redirect to="/" />;
      }
      if (language == "english")
        message = "The payment could not be processed. Please try again";
      else message = "لم تتم عملية الدفع. يرجى المحاولة مرة اخرى";

      paymentError = true;
    } else if (
      this.props.history.location.state &&
      !this.props.match.params.Tid
    )
      message = this.props.history.location.state.message;
    return (
      <div style={{ backgroundColor: "white", minHeight: window.innerHeight }}>
        <ProductHeader
          onBack={() => {
            this.props.clearLastOrder();
            this.props.history.replace("/");
          }}
        />
        <div className="free-space-190-white"></div>
        {paymentError ? (
          <PaymentDeclined width="100" height="100" />
        ) : (
          <Error width="100" height="100" />
        )}
        <h1
          className="mt-3"
          dir={language == "english" ? "ltr" : "rtl"}
          style={{ fontFamily: language == "english" ? "Quicksand" : "Cairo" }}
        >
          {language == "english"
            ? paymentError
              ? "Payment Declined"
              : "Oops.."
            : paymentError
            ? "لم يتم الدفع"
            : "حدث خطأ"}
        </h1>
        <p
          className="mt-3 mx-auto mb-0"
          style={{ fontSize: "1rem", width: "90%" }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          {message
            ? message
            : language == "english"
            ? "Your order has not been placed. Please try again or contact us for help"
            : "عذرا، لم نتمكن من اتمام العملية. يرجى المحاولة مرة اخرى او الاتصال بنا للمساعدة"}
        </p>

        {!settings.enable_table_qr && (
          <div className="mt-3 w-100">
            <div
              className="row mt-5"
              style={{
                backgroundColor: "white",
                minHeight: 65,
                padding: "15px 5px",
                marginLeft: 0,
                marginRight: 0,
              }}
            >
              <div
                className={"col-6 d-flex ".concat(
                  language == "english" ? "text-left" : "text-right"
                )}
              >
                <span className="my-auto bold">
                  {language == "english" ? "Customer Name" : "اسم العميل"}:
                </span>
              </div>
              <div className="col-6 d-flex ">
                <span
                  className={"my-auto ".concat(
                    language == "english" ? "ml-auto" : "mr-auto"
                  )}
                >
                  {customerContact?.name || ""}
                </span>
              </div>

              <div
                className={"col-6 d-flex ".concat(
                  language == "english" ? "text-left" : "text-right"
                )}
                style={{ marginTop: 20 }}
              >
                <span className="my-auto bold">
                  {language == "english" ? "Phone Number" : "رقم الهاتف"}:
                </span>
              </div>
              <div className="col-6 d-flex " style={{ marginTop: 20 }}>
                <span
                  className={"my-auto ".concat(
                    language == "english" ? "ml-auto" : "mr-auto"
                  )}
                >
                  {customerContact?.phone || ""}
                </span>
              </div>
            </div>
          </div>
        )}

        {(this.state.loading || !!failedPromise) && (
          <div className="w-100">
            {this.state.loading && (
              <CircularProgress color="primary" style={{ marginTop: 80 }} />
            )}
            {!!failedPromise && (
              <div
                className="row"
                style={{
                  backgroundColor: "white",
                  minHeight: 65,
                  padding: "0px 5px",
                  marginLeft: 0,
                  marginRight: 0,
                }}
              >
                <div
                  className={"col-6 d-flex ".concat(
                    language == "english" ? "text-left" : "text-right"
                  )}
                >
                  <span className="my-auto bold">
                    {language == "english" ? "Date" : "التاريخ"}:
                  </span>
                </div>
                <div className="col-6 d-flex ">
                  <span
                    className={"my-auto ".concat(
                      language == "english" ? "ml-auto" : "mr-auto"
                    )}
                  >
                    {failedPromise.created}
                  </span>
                </div>

                <div
                  className={"col-6 d-flex ".concat(
                    language == "english" ? "text-left" : "text-right"
                  )}
                  style={{ marginTop: 20 }}
                >
                  <span className="my-auto bold">
                    {language == "english" ? "Result" : "النتيجة"}:
                  </span>
                </div>
                <div className="col-6 d-flex " style={{ marginTop: 20 }}>
                  <span
                    className={"my-auto ".concat(
                      language == "english" ? "ml-auto" : "mr-auto"
                    )}
                    style={{ color: "red" }}
                  >
                    {!!failedPromise.raw_payment_response
                      ? failedPromise.raw_payment_response
                          .split("result=")[1]
                          ?.split("&")[0]
                          .replace("+", " ")
                      : "Failed"}
                  </span>
                </div>
                <div
                  className={"col-6 d-flex ".concat(
                    language == "english" ? "text-left" : "text-right"
                  )}
                  style={{ marginTop: 20 }}
                >
                  <span className="my-auto bold">Payment ID:</span>
                </div>
                <div className="col-6 d-flex " style={{ marginTop: 20 }}>
                  <span
                    className={"my-auto ".concat(
                      language == "english" ? "ml-auto" : "mr-auto"
                    )}
                  >
                    {failedPromise.payment_payid}
                  </span>
                </div>

                <div
                  className={"col-6 d-flex ".concat(
                    language == "english" ? "text-left" : "text-right"
                  )}
                  style={{ marginTop: 20 }}
                >
                  <span className="my-auto bold">
                    {language == "english" ? "Tracking ID" : "رقم التتبع"}:
                  </span>
                </div>
                <div className="col-6 d-flex " style={{ marginTop: 20 }}>
                  <span
                    className={"my-auto ".concat(
                      language == "english" ? "ml-auto" : "mr-auto"
                    )}
                  >
                    {failedPromise.tracking_id}
                  </span>
                </div>

                <div
                  className={"col-6 d-flex ".concat(
                    language == "english" ? "text-left" : "text-right"
                  )}
                  style={{ marginTop: 20 }}
                >
                  <span className="my-auto bold">
                    {language == "english" ? "Total" : "المجموع"}:
                  </span>
                </div>
                <div className="col-6 d-flex " style={{ marginTop: 20 }}>
                  <span
                    className={"my-auto ".concat(
                      language == "english" ? "ml-auto" : "mr-auto"
                    )}
                  >
                    {failedPromise.total.toFixed(settings.currency_decimals)}{" "}
                    {failedPromise.currency}
                  </span>
                </div>
              </div>
            )}
          </div>
        )}
        <div className="free-space-190-white"></div>
        <div className="free-space-190-white"></div>
        <ActionButton
          action={language == "english" ? "Try again" : "حاول مرة اخرى"}
          onClick={() => {
            this.props.clearLastOrder();
            this.props.history.replace("/checkout/confirmation");
            window.location.reload();
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    lastOrder: state.PastOrders.lastOrder,
    settings: state.store.store.settings,
    customerContact: state.customers?.customerContact,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    clearLastOrder: () => dispatch(clearLastOrder()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(index);
